// DS: TA0.3
import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useState, useCallback } from 'react';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import PlusIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import CheckIcon from '@wix/da-ds/pkg/Icons/24x24/Check';
import CloseIcon from '@wix/da-ds/pkg/Icons/24x24/Close';
import { useWatchButton } from '../../WatchButton/useWatchButton';
const ProfileOwnerWatchButton = ({ disabled , className , disableClickHandler , user , initialData , onClick: onClickProp , renderCustomText , onToggleWatchSuccess , allowUnsubscribe , isWatchingBack =false  })=>{
    var _user_isWatching;
    const { text , isWatching , isLoading , biData , onClick  } = useWatchButton(user, (_user_isWatching = user.isWatching) !== null && _user_isWatching !== void 0 ? _user_isWatching : initialData === null || initialData === void 0 ? void 0 : initialData.isWatching, isWatchingBack, disabled, onToggleWatchSuccess, allowUnsubscribe);
    const [isMouseOver, setIsMouseOver] = useState(false);
    const [isNewWatching, setIsNewWatching] = useState(false);
    const handleClick = useCallback((e)=>{
        if (disableClickHandler) {
            return;
        }
        setIsNewWatching(!isWatching);
        onClick();
        onClickProp && onClickProp(e);
    }, [
        disableClickHandler,
        isWatching,
        onClick,
        onClickProp
    ]);
    const handleMouseLeave = useCallback((e)=>{
        // when you click on button's child elements,
        // the mouseleave event triggers
        if (e.currentTarget !== e.target) {
            return;
        }
        setIsNewWatching(false);
        setIsMouseOver(false);
    }, []);
    const handleMouseEnter = useCallback(()=>{
        setIsMouseOver(true);
    }, []);
    const Button = isWatching ? SolidButton : BrandedButton;
    const buttonVariantProps = isWatching ? {
        variant: 'approval-green',
        priority: 'secondary'
    } : {
        variant: 'brand-green'
    };
    let icon = PlusIcon;
    if (isWatching && !isLoading) {
        icon = CheckIcon;
        if (isMouseOver && !isNewWatching) {
            icon = CloseIcon;
        }
    }
    return /*#__PURE__*/ React.createElement(Button, _extends({
        size: "large"
    }, buttonVariantProps, {
        icon: icon,
        className: className,
        onClick: handleClick,
        onMouseLeave: handleMouseLeave,
        onMouseEnter: handleMouseEnter,
        loading: isLoading,
        disabled: disabled,
        biData: biData
    }), renderCustomText ? renderCustomText(isWatching) : text);
};
ProfileOwnerWatchButton.displayName = 'ProfileOwnerWatchButton';
export default ProfileOwnerWatchButton;
